import { Link } from 'react-router-dom';
import Button from '@/components/ui/Button';
import { HomeIcon } from '@heroicons/react/24/outline';

export default function NotFoundPage() {
  return (
    <div className="flex items-center justify-center py-16">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white px-6 py-12 text-center shadow-sm">
        <div>
          <p className="font-serif text-6xl font-semibold text-primary-800">404</p>
          <h1 className="mt-4 font-serif text-3xl font-semibold text-slate-950">
            Page not found
          </h1>
          <p className="mt-2 text-sm leading-6 text-slate-600">
            Sorry, we couldn&apos;t find the page you&apos;re looking for.
          </p>
        </div>
        <div>
          <Link to="/">
            <Button size="lg">
              <HomeIcon className="mr-2 h-5 w-5" />
              Go back home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
